import { makeAutoObservable } from "mobx";
import { ZAttrMeta } from "src/business/attribute";
import {
  AttrUserType,
  getAttrUserType,
} from "src/business/attribute/AttrUserType";
import { mdmDeepEqual } from "src/common/mdmDeepEqual";
import { onError } from "src/common/onError";

import { AttrEditorData, edit2meta, meta2edit } from "./AttrEditorField";

export type AttrEditorV2Context = {
  isNew: boolean;
  usedNames: string[];
  ownerName?: string;
};

export class AttrEditorV2Store {
  constructor(
    srcAttr: ZAttrMeta,
    public readonly ctx: AttrEditorV2Context,
  ) {
    this.srcAttr = JSON.parse(JSON.stringify(srcAttr)); // нужно избавиться от Proxy. Иначе не работает сравнение в onChange
    makeAutoObservable(this, {
      srcAttr: false,
      ctx: false,
      getInitialValues: false,
      onChange: false,
    });
  }

  readonly srcAttr: ZAttrMeta;

  get attrType(): AttrUserType | undefined {
    return getAttrUserType(this.srcAttr);
  }

  get title(): string {
    const { isNew, ownerName } = this.ctx;
    if (!isNew) return "Редактирование атрибута";
    const base = "Новый атрибут";
    return ownerName ? `${base} в ${ownerName}` : base;
  }

  getInitialValues(): AttrEditorData {
    // Данная функция не является реактивной, т.к. вызывается только один раз при инициализации формы
    return meta2edit(this.srcAttr);
  }

  makeResult(currentValues: AttrEditorData): ZAttrMeta {
    return edit2meta(this.srcAttr, currentValues);
  }

  changed = false;

  setChanged(value: boolean) {
    this.changed = value;
  }

  onChange(values: AttrEditorData) {
    // Данная функция не требует реактивности, т.к. является обработчиком события
    // Реактивное поведение возникает только в процессе вызова setChanged (на него реагирует состояние кнопки сабмита)
    try {
      const srcAttr = edit2meta(this.srcAttr, this.getInitialValues());
      const newAttr = edit2meta(this.srcAttr, values);
      const isEqual = mdmDeepEqual(srcAttr, newAttr);
      this.setChanged(!isEqual);
    } catch (e) {
      onError(e);
    }
  }
}
